import afSharePage from "../../../Assets/sharePageFunction";
(function() {
    const options = {
        rootMargin: '0% 0% -85% 0%'
    }
    const links = [...document.querySelectorAll('aside a[href^="#"]')];
    const linkSelectors = links.map(link => link.href.split('#').slice(-1)).map(id => `#${id}`).join(', ');

    if (linkSelectors) {
        const observer = new IntersectionObserver(entries => {
            const entry = [...entries].filter(entry => entry.isIntersecting)[0];
            const id = entry?.target?.id;
            if (id) {
                links.map(link => link.classList.remove('active'));
                document.querySelector('aside a[href="#' + id + '"]').classList.add('active');
            }
        }, options);

        [...document.querySelectorAll(linkSelectors)].map(element => observer.observe(element));
    }

    document.addEventListener('DOMContentLoaded', () => {
        if(document.querySelectorAll('.table-of-content li a').length !== 0) {
            document.querySelectorAll('.table-of-content li a').forEach((item) => {
                item.addEventListener('click', (event) => {
                    localStorage.setItem('blog-toc-clicked', 'true');
                })
            })
        }
    })


    //Sharing button - start
    const shareButtonMobile = document.querySelectorAll(".af-blog-page-mobile-intro-button-share")[0];
    const shareTitle = null;

    window.addEventListener("load",function() {afSharePage(shareButtonMobile,shareTitle)})
    //Sharing button - end

    /* It assigns category query to a back to button's href in case the category
    ** exists so that only blogs of the selected categories can be shown on an index page
    */
    function afLoadBlogCategoryForBackToButton() {
        const blogCategory = sessionStorage.getItem("blogCategory");
        const originalHref = document.querySelectorAll("#af-blog-page-mobile-intro-buttons .af-blog-page-mobile-intro-button-back-to")[0];
        if(blogCategory && originalHref) {
            originalHref.href = originalHref.href + "?category=" + blogCategory;
        }
    }

    window.addEventListener("load",afLoadBlogCategoryForBackToButton);

    //Toggling content summary accordion for mobile
    const accordionHeadline = document.getElementById("table-of-content-headline");
    //Content summary list
    const list = document.querySelectorAll(".table-of-content .toc")[0];
    function afTogglingContentSummaryAccordion() {
        if(!list.classList.contains("toc-shown")) {
            list.classList.add("toc-shown")
        }
        else {
            list.classList.remove("toc-shown")
        }
    }
    accordionHeadline.addEventListener("click",afTogglingContentSummaryAccordion)
})();
